import React, {useState} from 'react';
import {
    SelectInput
} from 'react-admin';
import {STORE_TYPES, STORE_TYPE_SHOPIFY} from '../global/storeTypes';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FieldDescription from './FieldDescription';
import FieldDivider from './FieldDivider';
import StoreIntegrationFormShopify from './StoreIntegrationFormShopify';
import {makeStyles} from '@material-ui/core/styles';

const useTitleStoreIntegrationStyles = makeStyles((theme) => ({
    accordionDetail: {
        flexDirection: 'column'
    },
    accordionSummary: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)'
    },
    container: {lineHeight: 1.4},
}));

/**
 * A component for displaying an External Store Integration Form in an Edit view
 *
 * @param record
 * @param type
 * @return {JSX.Element}
 * @constructor
 */
const TitleStoreIntegration = ({record, type = 'create'}) => {

    const [storeType, setStoreType] = useState(null);

    const classes = useTitleStoreIntegrationStyles();

    const onSelectStoreType = (e) => {
        setStoreType(e.target.value);
    };

    return (
        <div className={classes.container}>
            <FieldDivider type="divider" margin="bottom"/>
            {type === 'create' &&
                <>
                    <FieldDescription
                        header={true} marginBottom={true} text="External Store Integration"/>
                    <FieldDescription
                        description={true}
                        margin="bottom"
                        text={`If this Title should be affiliated with an external store such 
                        as ${STORE_TYPE_SHOPIFY}, toggle open Create Integration and enter values below.`}
                    />
                </>
            }
            {type === 'edit' && record.store_type &&
                <>
                    <FieldDescription
                        header={true} marginBottom={true}
                        text={`External Store Integration (${record.store_type})`}
                    />
                </>
            }
            <FieldDivider type="break"/>

            {type === 'create' &&
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="Integration-Form-content"
                        id="Integration-Form-header"
                        className={classes.accordionSummary}
                    >
                        <FieldDescription header={true} margin="bottom" text="Create Integration"/>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetail}>
                        <FieldDescription
                            description={true} marginBottom={true}
                            text='Associate this Title with an external store by selecting a store type.'
                        />
                        <FieldDivider type="break"/>
                        <SelectInput
                            key="new_store_type" source="new_store_type" label="Store Type"
                            choices={STORE_TYPES}
                            allowEmpty={true}
                            defaultValue=""
                            onChange={(e) => onSelectStoreType(e)}
                            className="input-inline input-400"
                        />
                        <FieldDivider type="break"/>

                        {/* Store Type: Shopify */}
                        {storeType === 'Shopify' &&
                            <StoreIntegrationFormShopify type="create" record={record}/>
                        }
                    </AccordionDetails>
                </Accordion>
            }

            {type === 'edit' &&
                <>
                    {/* Store Type: Shopify */}
                    {record.integrations && record.store_type === 'Shopify' &&
                        <StoreIntegrationFormShopify type="edit" record={record}/>
                    }
                </>
            }

            <FieldDivider type="break" margin="bottom"/>
        </div>
    );
};

export default TitleStoreIntegration;
